<template>
    <cic-popup
        :title="item.accountId ? $t('Edit Trustpilot Account') : $t('New Trustpilot Account')"
        :saveable="$store.hasRight('EDIT_ACCESS_TYPE_21')"
        @blur="$emit('blur')"
        @input="validate"
    >
        <div class="item-form">
            <ul style="display: grid">
                <li class="form-item-centred">
                    <div class="form-label-first">{{ $t('Name') }}:</div>
                    <div>
                        <cic-textbox
                            id="accountName"
                            :value="item.accountName"
                            :placeholder="$t('Label for Trustpilot account')"
                            @input="(val) => updateFieldValue('accountName', val)"
                        />
                    </div>
                </li>

                <li class="form-item-centred">
                    <div class="form-label">{{ $t('API Key') }}:</div>
                    <div>
                        <cic-textbox
                            id="apiKey"
                            :value="item.apiKey"
                            :placeholder="$t('API Key from Trustpilot API')"
                            @input="(val) => updateFieldValue('apiKey', val)"
                        />
                    </div>
                </li>

                <li class="form-item-centred">
                    <div class="form-label">{{ $t('Secret') }}:</div>
                    <div>
                        <cic-textbox
                            id="apiSecret"
                            :value="item.apiSecret"
                            :placeholder="$t('Secret from Trustpilot API')"
                            @input="(val) => updateFieldValue('apiSecret', val)"
                        />
                    </div>
                </li>

                <li class="form-item-centred">
                    <div class="form-label">{{ $t('Redirect URI (Copy to Trustpilot)') }}:</div>
                    <div style="display: inline-flex; margin-top: 5px">
                        <p class="break-word" style="width: 185px; margin-top: 0">
                            {{ formatRedirectUrl }}
                        </p>
                        <cic-button
                            id="copy_url"
                            class="copy-button"
                            style="margin-left: 15px"
                            @click="copyRedirectUrl"
                        >
                            {{ $t('Copy') }}
                        </cic-button>
                    </div>
                </li>
            </ul>
        </div>
    </cic-popup>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicPopup from '@/components/CicPopup';
    import CicTextbox from '@/components/inputs/CicTextbox';

    export default {
        name: 'EditTrustpilotAccount',
        components: {
            CicTextbox,
            CicButton,
            CicPopup,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
        },
        emits: ['blur', 'change', 'input'],
        data() {
            return {
                apiKeyInvalid: false,
                apiSecretInvalid: false,
                accountNameInvalid: false,
            };
        },
        computed: {
            formatRedirectUrl() {
                return window.location.hostname;
            },
        },
        methods: {
            updateFieldValue(field, value) {
                this.$emit('change', field, value);
            },

            validate() {
                this.apiKeyInvalid = this.item.apiKey.trim() === '';
                this.apiSecretInvalid = this.item.apiSecret.trim() === '';
                this.accountNameInvalid = this.item.accountName.trim() === '';

                if (this.apiKeyInvalid || this.apiSecretInvalid || this.accountNameInvalid) {
                    return;
                }

                this.$emit('input');
            },

            copyRedirectUrl() {
                const elem = document.createElement('textarea');
                document.body.appendChild(elem);
                elem.value = window.location.hostname;
                elem.select();
                document.execCommand('copy');
                document.body.removeChild(elem);
            },
        },
    };
</script>
